import { useRouterState } from '@tanstack/react-router'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { Breadcrumb } from '@/components/elements'

type Props = Omit<ComponentPropsWithoutRef<typeof Breadcrumb>, 'items'>

export const AppBreadcrumb: FC<Props> = (props) => {
  // パンくずリストのタイトル取得方法として routeContext を使用する方法では、APIから取得したデータでタイトルを生成することが難しい。
  // meta を使用すると、 loaderData が使用可能となるため問題は解決できる。
  // そのため、本来の用途であるページタイトルの生成からはずれるが、meta を使用してパンくずリストを生成している。
  // https://github.com/TanStack/router/discussions/895
  const breadcrumbs = useRouterState({
    select: (state) =>
      state.matches
        .map((match) => {
          const title = match.meta?.find((tag) => tag.title)?.title

          return title
            ? {
                title,
                href: match.pathname
              }
            : null
        })
        .filter(
          (breadcrumb): breadcrumb is NonNullable<typeof breadcrumb> =>
            breadcrumb !== null
        )
  })

  return (
    <Breadcrumb
      {...props}
      items={breadcrumbs.map(({ title, href }) => ({
        title,
        href
      }))}
    />
  )
}
